import React, { memo } from 'react';

import { Box, IconButton } from '@mui/material';
import { ResetIcon } from '@sharedCR/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';

import {
  errorWrapperStyles,
  getContentWrapperStyles,
  wrapperStyles,
} from './ErrorHandlingLayout.styles';

const defaultObject = {};

const ErrorHandlingLayout = ({
  children,
  onClick,
  isError,
  classes = defaultObject,
  dataTestId = null,
}) => (
  <Box className={classes.wrapper} sx={wrapperStyles}>
    {isError && (
      <Box className={classes.errorWrapper} sx={errorWrapperStyles}>
        <IconButton disableFocusRipple disableRipple data-testid={dataTestId} onClick={onClick}>
          <ResetIcon size={IconSize[40]} />
        </IconButton>
      </Box>
    )}

    <Box className={classes.contentWrapper} sx={getContentWrapperStyles({ isError })}>
      {children}
    </Box>
  </Box>
);

ErrorHandlingLayout.propTypes = {
  isError: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  classes: PropTypes.object,
  dataTestId: PropTypes.string,
};

export default memo(ErrorHandlingLayout);
